import { Question } from '../Model/Question';
export class QuestionsService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(questionId) {
        if (questionId) {
            const response = await this.apiService.get('question/' + questionId);
            if (!response.ok) {
                throw new Error(`Error al obtener la respuesta.`);
            }
            const content = await response.json();
            if (content) {
                const question = new Question(content);
                return question;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener QuestionId.`);
        }
    }
    async findQuestions() {
        const response = await this.apiService.get(`questions`);
        if (!response.ok) {
            throw new Error(`Error al obtener las preguntas.`);
        }
        const content = await response.json();
        return content.map(question => new Question(question).getState());
    }
}
